export default __webpack_public_path__ + "static/media/carta.04b657b8.png";